import { Box, Text, Icon, useDisclosure } from '@chakra-ui/react';
import { FaBell, FaBullhorn } from 'react-icons/fa'; // React icon for announcements
import { format } from 'date-fns'; // For formatting date and time
import NotificationView from './NotificationView';
import { MdEventAvailable } from 'react-icons/md';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { readNotification } from 'api';
import { useDispatch } from 'react-redux';
import { newNotifyItem } from './../../../redux/webSocketReducer';
import { NOTIFICATION_TYPES } from 'constants/notification.contants';
import { useReadNotification } from 'hooks/notification/useReadNotification';

const NotificationBox = ({ data, users }) => {
	const { type, message, createdAt } = data?.notification;

	const { isOpen, onOpen, onClose } = useDisclosure();

	const { readNotification } = useReadNotification();

	const [messageType, setMessageType] = useState('notification');
	// const [message, setMessage] = useState('');

	const getSender = useCallback(
		(sender_id) => {
			return users?.find((user) => user._id === sender_id);
		},
		[users],
	);

	useEffect(() => {
		let messageType = '';

		switch (type) {
			case NOTIFICATION_TYPES.ANNOUNCEMENT:
				messageType = 'announcement';
				break;

			case NOTIFICATION_TYPES.INTERVIEW_INVITE:
				messageType = 'invite';

				break;

			case NOTIFICATION_TYPES.LEAD_ASSIGNED:
			case NOTIFICATION_TYPES.LEAD_BULK_ASSIGNED:
				// const sender_id = notification?.sender_id;
				// const sender = getSender(sender_id);

				messageType = 'notification';

				// message = `The lead '${notification?.lead_name}' has been assigned ${
				// 	sender?.fullName ? `by the ${sender.fullName}` : ''
				// }.`;
				break;

			default:
				messageType = 'notification';
				break;
		}

		setMessageType(messageType);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [type]);

	const getIconProps = () => {
		if (messageType === 'announcement') {
			return { icon: FaBullhorn, bg: 'brand.500', title: 'Announcement' };
		} else if (messageType === 'invite') {
			return {
				icon: MdEventAvailable,
				bg: 'green.500',
				title: 'Interview Invite',
			};
		} else {
			return {
				icon: FaBell,
				bg: 'rgba(40, 167, 69, 0.7)',
				title: 'Notification',
			};
		}
	};

	const { icon, bg, title } = getIconProps();
	const formattedDate = format(new Date(createdAt), ' h:mm a MMM d, yyyy');

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const markAsRead = async (id) => {
		try {
			await readNotification(id);
		} catch (error) {
			console.log(error);
		}
	};

	const handleNotificationOpen = async () => {
		if (!data?.read) {
			await markAsRead(data?.notification?._id);
			// dispatch(newNotifyItem({ type: messageType, message }));
		}

		if (
			type === NOTIFICATION_TYPES.ANNOUNCEMENT ||
			type === NOTIFICATION_TYPES.INTERVIEW_INVITE
		) {
			return onOpen();
		}

		if (type === NOTIFICATION_TYPES.LEAD_ASSIGNED) {
			if (!data?.notification) return;
			navigate(
				`/lead?page=1&pageSize=40&lead=${data?.notification?.metadata?.leadId}`,
			);
		}
	};

	return (
		<>
			<Box
				onClick={handleNotificationOpen}
				p={2}
				borderRadius='md'
				display='flex'
				alignItems='center'
				gap={3}
				bg={data?.read ? 'transparent' : 'green.100'}
				border='none'
				outline='none'
				cursor='pointer'
				transition='background 0.3s ease, box-shadow 0.3s ease'
			>
				{/* Icon */}
				<Box
					bg={bg}
					borderRadius='full'
					p={1}
					boxSize={10}
					display='flex'
					alignItems='center'
					justifyContent='center'
					title={title}
				>
					<Icon as={icon} boxSize={6} color='white' />
				</Box>

				{/* Message Details */}
				<Box flex='1'>
					<Text
						fontSize='sm'
						width={{ sm: '150px', md: '250px' }}
						color='gray.700'
						lineHeight='1.2'
						style={{
							overflow: 'hidden',
							display: '-webkit-box',
							WebkitLineClamp: 2,
							WebkitBoxOrient: 'vertical',
						}}
					>
						{message}
					</Text>

					<Text fontSize='xs' color='gray.800' mt={1}>
						{formattedDate}
					</Text>
				</Box>
			</Box>

			{isOpen && (
				<NotificationView
					title={title}
					item={data?.notification}
					type={messageType}
					isOpen={isOpen}
					onClose={onClose}
				/>
			)}
		</>
	);
};

export default NotificationBox;
